import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'regularPrice': 0,
  'greyPrice': 0,
  'description': '',
  'errorMessage': '',
  'stockTmc': 0,
  'productionTime': 0,
  'difFactor': 'NO',
};

export const partQuotation = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCH_PART_PRICE_INFO_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
      'errorMessage': '',
    }),
    [ActionTypes.FETCH_PART_PRICE_INFO_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'leadTime': 0,
      'regularPrice': 0,
      'greyPrice': 0,
      'description': '',
      'errorMessage': action.error.data.error,
      'stockTmc': 0,
      'productionTime': 0,
      'difFactor': 'NO',
    }),
    [ActionTypes.FETCH_PART_PRICE_INFO_SUCCESS]: (state, action) => ({
      ...state,
      ...action.response.data,
      'loading': false,
    }),
    [ActionTypes.CLEAR_PRICE_AND_FOB]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
  })(state, action);
};
